import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    Toaster,
} from "@postcheesy/ui-lib/molecules";
import React from "react";
import { Container } from "../../components/layouts/container";
import { Layout } from "../../components/layouts/layout";
import { ROUTES } from "../../resources/constants/routes";
import { ChangePasswordForm } from "../../components/sections/forms/ChangePassword";
import { Button } from "@postcheesy/ui-lib/atoms";
import { useNavigate } from "react-router-dom";


export const ChangePassword: React.FC = () => {
    const navigate = useNavigate();
    const [success, setSuccess] = React.useState(false);

    return (
        <Layout>
            <Toaster />
            <Container className="py-6">
                <div className="relative mx-auto grid h-full w-fit grid-cols-1 items-start justify-center">
                    <section className="lg:my-18 container mx-auto my-12 h-fit max-w-xl py-8 md:my-12 2xl:my-32">
                        <Button variant="link" onClick={() => navigate(ROUTES.PROFILE)}>{"< Retourner au profil"}</Button>
                        {success ? (
                            <Card className="w-full">
                                <CardHeader>
                                    <CardTitle className="text-2xl">{"Mot de passe changé"}</CardTitle>
                                    <CardDescription className="w-fit text-pretty">
                                        Votre mot de passe a été changé avec succès.
                                    </CardDescription>
                                </CardHeader>
                            </Card>
                        ) : (
                            <Card className="w-full">
                                <CardHeader>
                                    <CardTitle className="text-2xl">{"Changer votre mot de passe"}</CardTitle>
                                    <CardDescription className="w-fit text-pretty">
                                        Suivez les instructions ci-dessous changer votre mot de passe.
                                    </CardDescription>
                                </CardHeader>
                                <CardContent>
                                    <ChangePasswordForm setSuccess={setSuccess} />
                                </CardContent>
                            </Card>
                        )}
                    </section>
                </div>
            </Container>
        </Layout >
    );
}
